import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-70753f58"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "edit-page-content-box"
};
const _hoisted_2 = {
  class: "edit-page-content-container"
};
const _hoisted_3 = {
  class: "edit-page-content-change"
};
const _hoisted_4 = {
  class: "edit-page-content-change-title"
};
const _hoisted_5 = {
  class: "edit-page-content-change-title-text"
};
const _hoisted_6 = {
  key: 0,
  class: "group-content-with-different-key"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  key: 0,
  class: "translate-content-div"
};
const _hoisted_9 = {
  class: "translate-icon-div"
};
const _hoisted_10 = {
  class: "translate-content"
};
const _hoisted_11 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(['edit-page-content-inner-box', 'withGap'])
};
const _hoisted_12 = {
  class: "title"
};
const _hoisted_13 = {
  key: 0,
  class: "translate-content-div"
};
const _hoisted_14 = {
  class: "translate-icon-div"
};
const _hoisted_15 = {
  class: "translate-content"
};
const _hoisted_16 = {
  key: 0,
  class: "edit-page-content-amazon"
};
const _hoisted_17 = {
  class: "edit-page-content-amazon-title"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "edit-page-content-amazon-title-text"
}, " Currently on Amazon ", -1));
const _hoisted_19 = {
  key: 0,
  class: "group-content-with-different-key"
};
const _hoisted_20 = {
  class: "title"
};
const _hoisted_21 = {
  key: 0,
  class: "translate-content-div"
};
const _hoisted_22 = {
  class: "translate-icon-div"
};
const _hoisted_23 = {
  class: "translate-content"
};
const _hoisted_24 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(['edit-page-content-inner-box', 'withGap'])
};
const _hoisted_25 = {
  class: "title"
};
const _hoisted_26 = {
  key: 0,
  class: "translate-content-div"
};
const _hoisted_27 = {
  class: "translate-icon-div"
};
const _hoisted_28 = {
  class: "translate-content"
};
const _hoisted_29 = {
  key: 1,
  class: "edit-page-content-translate"
};
const _hoisted_30 = {
  class: "edit-page-content-translate-title"
};
const _hoisted_31 = {
  class: "edit-page-content-translate-title-text"
};
const _hoisted_32 = {
  key: 0,
  class: "group-content-with-different-key"
};
const _hoisted_33 = {
  class: "title"
};
const _hoisted_34 = {
  key: 0,
  class: "translate-content-div"
};
const _hoisted_35 = {
  class: "translate-icon-div"
};
const _hoisted_36 = {
  class: "translate-content"
};
const _hoisted_37 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass(['edit-page-content-inner-box', 'withGap'])
};
const _hoisted_38 = {
  class: "title"
};
const _hoisted_39 = {
  key: 0,
  class: "translate-content-div"
};
const _hoisted_40 = {
  class: "translate-icon-div"
};
const _hoisted_41 = {
  class: "translate-content"
};
const _hoisted_42 = {
  key: 0,
  class: "edit-page-content-disabled"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_edit_page_content_preview = _resolveComponent("edit-page-content-preview");
  const _component_edit_page_content_edit = _resolveComponent("edit-page-content-edit");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString($props.title), 1)]), $options.typeOfContentIsString($options.omnyContent) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString($data.attribute_title_map[$props.type]), 1), _createElementVNode("div", {
    class: _normalizeClass(['edit-page-content-edit-inner', {
      scroll: $props.type == 'product_description'
    }])
  }, [_createVNode(_component_edit_page_content_edit, {
    modelValue: $options.omnyContent,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.omnyContent = $event),
    scroll: $props.type == 'product_description',
    allowHtmlInputAndSpecialCharacters: $props.type == 'product_description',
    minimum_characters: $options.characterRangePerContentType($props.type).min,
    maximum_characters: $options.characterRangePerContentType($props.type).max,
    type: $props.type,
    show_dropdown: $options.aiContent || $props.keyword_sidebar_open,
    show_comparison: $props.show_comparison,
    text_with_diffs: $data.omny_text_with_diffs,
    onHideComparison: _cache[1] || (_cache[1] = $event => $options.hideComparison()),
    onHideTranslation: _cache[2] || (_cache[2] = $event => $options.hideTranslation()),
    onCheckIsValid: $options.isValid
  }, {
    translate: _withCtx(() => [$props.show_translation ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(_component_app_icon, {
      icon: "translate",
      size: 13.333,
      color: "#ADADAD"
    })]), _createElementVNode("div", _hoisted_10, _toDisplayString($options.omnyContentTranslation), 1)])) : _createCommentVNode("", true)]),
    default: _withCtx(() => [$options.aiContent || $props.keyword_sidebar_open ? (_openBlock(), _createBlock(_component_edit_page_content_preview, {
      key: 0,
      text: $options.amazonContent,
      show_header: ""
    }, null, 8, ["text"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue", "scroll", "allowHtmlInputAndSpecialCharacters", "minimum_characters", "maximum_characters", "type", "show_dropdown", "show_comparison", "text_with_diffs", "onCheckIsValid"])], 2)])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.omnyContent, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "group-content-with-different-key"
    }, [_createElementVNode("div", _hoisted_12, _toDisplayString(typeof $data.attribute_title_map[$props.type] == "string" ? $data.attribute_title_map[$props.type] : $data.attribute_title_map[$props.type][index]), 1), _createElementVNode("div", {
      class: _normalizeClass(['edit-page-content-edit-inner', {
        scroll: $props.type == 'product_description'
      }])
    }, [_createVNode(_component_edit_page_content_edit, {
      modelValue: $options.omnyContent,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $options.omnyContent = $event),
      index: index,
      scroll: $props.type == 'product_description',
      allowHtmlInputAndSpecialCharacters: $props.type == 'product_description',
      minimum_characters: $options.characterRangePerContentType($props.type).min,
      maximum_characters: $options.characterRangePerContentType($props.type).max,
      type: $props.type,
      show_dropdown: $options.aiContent || $props.keyword_sidebar_open,
      show_comparison: $props.show_comparison,
      text_with_diffs: $data.omny_text_with_diffs[index],
      onHideComparison: _cache[4] || (_cache[4] = $event => $options.hideComparison()),
      onHideTranslation: _cache[5] || (_cache[5] = $event => $options.hideTranslation()),
      onCheckIsValid: $options.isValid
    }, {
      translate: _withCtx(() => [$props.show_translation ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_app_icon, {
        icon: "translate",
        size: 13.333,
        color: "#ADADAD"
      })]), _createElementVNode("div", _hoisted_15, _toDisplayString($options.omnyContentTranslation[index]), 1)])) : _createCommentVNode("", true)]),
      default: _withCtx(() => [$options.aiContent || $props.keyword_sidebar_open ? (_openBlock(), _createBlock(_component_edit_page_content_preview, {
        key: 0,
        text: $options.amazonContent[index],
        show_header: ""
      }, null, 8, ["text"])) : _createCommentVNode("", true)]),
      _: 2
    }, 1032, ["modelValue", "index", "scroll", "allowHtmlInputAndSpecialCharacters", "minimum_characters", "maximum_characters", "type", "show_dropdown", "show_comparison", "text_with_diffs", "onCheckIsValid"])], 2)]);
  }), 128))]))]), !$props.show_ai_generated_content && !$props.show_ai_translated_content && !$props.keyword_sidebar_open ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_app_icon, {
    icon: "amazon"
  }), _hoisted_18]), $options.typeOfContentIsString($options.amazonContent) ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString($data.attribute_title_map[$props.type]), 1), _createElementVNode("div", {
    class: _normalizeClass(['edit-page-content-inner', {
      scroll: $props.type == 'product_description'
    }])
  }, [_createVNode(_component_edit_page_content_preview, {
    text: $options.amazonContent,
    show_comparison: $props.show_comparison,
    text_with_diffs: $data.amazon_text_with_diffs
  }, {
    default: _withCtx(() => [$props.show_translation ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_app_icon, {
      icon: "translate",
      size: 13.333,
      color: "#ADADAD"
    })]), _createElementVNode("div", _hoisted_23, _toDisplayString($options.amazonContentTranslation || " "), 1)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["text", "show_comparison", "text_with_diffs"])], 2)])) : (_openBlock(), _createElementBlock("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.amazonContent, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "group-content-with-different-key"
    }, [_createElementVNode("div", _hoisted_25, _toDisplayString(typeof $data.attribute_title_map[$props.type] == "string" ? $data.attribute_title_map[$props.type] : $data.attribute_title_map[$props.type][index]), 1), (_openBlock(), _createBlock(_component_edit_page_content_preview, {
      key: index,
      text: item,
      "with-border": "",
      class: _normalizeClass(['edit-page-content-inner', {
        scroll: $props.type == 'product_description'
      }]),
      show_comparison: $props.show_comparison,
      text_with_diffs: $data.amazon_text_with_diffs[index]
    }, {
      default: _withCtx(() => [$props.show_translation ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_app_icon, {
        icon: "translate",
        size: 13.333,
        color: "#ADADAD"
      })]), _createElementVNode("div", _hoisted_28, _toDisplayString($options.amazonContentTranslation[index]), 1)])) : _createCommentVNode("", true)]),
      _: 2
    }, 1032, ["text", "class", "show_comparison", "text_with_diffs"]))]);
  }), 128))]))])) : _createCommentVNode("", true), $options.aiContent && !$props.keyword_sidebar_open ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(_component_app_icon, {
    icon: $props.active_menu == 'translate' ? 'translate' : 'ai',
    size: 20,
    color: "#312783"
  }, null, 8, ["icon"]), _createElementVNode("div", _hoisted_31, _toDisplayString($options.aiContentTitle), 1)]), $options.typeOfContentIsString($options.aiContent) ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, _toDisplayString($data.attribute_title_map[$props.type]), 1), _createElementVNode("div", {
    class: _normalizeClass(['edit-page-content-inner', {
      scroll: $props.type == 'product_description'
    }])
  }, [_createVNode(_component_edit_page_content_preview, {
    text: $options.aiContent,
    content_type: "ai",
    show_add: "",
    scroll: $props.type == 'product_description',
    onAdd: $options.onAdd
  }, {
    default: _withCtx(() => [$options.aiContentTranslate ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createVNode(_component_app_icon, {
      icon: "translate",
      size: 13.333,
      color: "#ADADAD"
    })]), _createElementVNode("div", _hoisted_36, _toDisplayString($options.aiContentTranslate || " "), 1)])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["text", "scroll", "onAdd"])], 2)])) : (_openBlock(), _createElementBlock("div", _hoisted_37, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.aiContent, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "group-content-with-different-key"
    }, [_createElementVNode("div", _hoisted_38, _toDisplayString(typeof $data.attribute_title_map[$props.type] == "string" ? $data.attribute_title_map[$props.type] : $data.attribute_title_map[$props.type][index]), 1), (_openBlock(), _createBlock(_component_edit_page_content_preview, {
      key: index,
      text: item,
      "with-border": "",
      content_type: "ai",
      class: _normalizeClass(['edit-page-content-inner', {
        scroll: $props.type == 'product_description'
      }]),
      show_option: "",
      option_number: index + 1,
      show_add: $props.type != 'bullet_points',
      onAdd: $options.onAdd
    }, {
      default: _withCtx(() => [$options.aiContentTranslate[index] ? (_openBlock(), _createElementBlock("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createVNode(_component_app_icon, {
        icon: "translate",
        size: 13.333,
        color: "#ADADAD"
      })]), _createElementVNode("div", _hoisted_41, _toDisplayString($options.aiContentTranslate[index] || " "), 1)])) : _createCommentVNode("", true)]),
      _: 2
    }, 1032, ["text", "class", "option_number", "show_add", "onAdd"]))]);
  }), 128))]))])) : _createCommentVNode("", true)]), $props.disabled ? (_openBlock(), _createElementBlock("div", _hoisted_42)) : _createCommentVNode("", true)]);
}